import { createContext, useContext } from 'react';

/**
 * Whether the subtree renders on the employee self-service (ESS) surface --
 * the phone design the Capacitor shell shows (`.wp-ess-shell` in
 * styles/wagepro-theme.css).
 *
 * Presentation only. `MyPayScreen` and `MyLeaveScreen` render in BOTH App
 * branches: the employee surface (where App.tsx sets this to `true`) and the
 * employer console's own My pay / My leave routes (where nothing sets it, so
 * it stays `false`). The screens read it to choose the phone layout or their
 * original console layout; no data, state or behaviour depends on it.
 */
const EssSurfaceContext = createContext(false);

export const EssSurfaceProvider = EssSurfaceContext.Provider;

/** `true` inside App.tsx's employee branch, `false` everywhere else. */
export function useIsEssSurface(): boolean {
  return useContext(EssSurfaceContext);
}
